import React, { Component } from 'react'
import { compose } from 'recompose'
import { meta } from 'helpers/decorators'
import OfficeLabels from '../Labels/OfficeLabels'

const enhance = compose(
    meta({
      title: 'My Organization - Labels',
      intlKey: 'pageTitle.my_organization_labels'
    })
)

class MyOrganizationLabels extends Component {
  render() {
    return <OfficeLabels />
  }
}

export default enhance(MyOrganizationLabels)
